import client from './client';

export interface SubmitFeedbackRequest {
  content: string;
  pageUrl?: string;
}

export interface SubmitFeedbackResponse {
  feedbackId: string;
}

export async function submitFeedback(
  request: SubmitFeedbackRequest
): Promise<SubmitFeedbackResponse> {
  const response = await client.post<SubmitFeedbackResponse>(
    '/api/v1/feedback',
    request
  );
  return response.data;
}
